<template>
  <div v-if="customData">
    <div class="swiper" v-if="customData.bannerH5">
      <img :src="customData.bannerH5" alt="" />
    </div>
    <div class="guide-award" v-if="registerPackage.length">
      <div class="guide-award-box">
        <div class="guide-award-title">
          <div><img src="@/assets/activityGuide/decorate2.png" alt="" /></div>
          <div class="text">注册即可获得新人大礼包</div>
          <div><img src="@/assets/activityGuide/decorate.png" alt="" /></div>
        </div>
        <div class="guide-award-main">
          <div
            v-for="(m, n) in registerPackage"
            :key="n"
            class="guide-award-content"
          >
            <div class="guide-award-item-name">
              {{ platformTypeEnum.getValueToRegisteredAwardLabel(m.platform) }}
            </div>
            <div
              class="guide-award-item"
              v-for="(x, y) in m.awardList"
              :key="y"
            >
              <template v-if="[AWARD_TYPE.FULL_REDUCTION,AWARD_TYPE.COUPONS].includes(x.awardType)">
                <div class="guide-award-text" :class="{ 'guide-award-text2':x.isDiscountType}">
                  <span class="guide-award-text-icon" v-if='!x.isDiscountType'>￥</span>
                  <span class="guide-award-text-price">{{ x.awardMoney }}</span>
                  <span class="fz14" v-if='x.isDiscountType'>折</span>
                </div>
                <div>
                  {{x.couponTypeText}}<span class="margin-left-xxs">x{{ x.count }}</span>
                </div>
              </template>
              <template v-else-if="x.awardType === AWARD_TYPE.COUPON_PACKAGE">
                <div class="guide-award-text">
                  <span class="guide-award-text-icon">￥</span>
                  <span class="guide-award-text-price">{{ x.awardMoney }}</span>
                </div>
                <div>
                  券包<span class="margin-left-xxs">x{{ x.count }}</span>
                </div>
              </template>
              <template v-else-if="x.awardType === AWARD_TYPE.SERVICE_COUPON">
                <div class="guide-award-text-center">
                  服务兑换券<span class="margin-left-xxs">x{{ x.count }}</span>
                </div>
              </template>
              <template v-else-if="x.awardType === AWARD_TYPE.BONUS_POINTS">
                <div class="guide-award-text">
                  <span class="guide-award-text-price">{{ x.awardScore }}</span>
                </div>
                <div>奖励积分</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="registered-custom content-text ql-bubble">
      <div
        class="ql-editor"
        v-html="customData.pageDetailH5"
        style="padding: 0"
      ></div>
    </div>
  </div>
</template>

<script>
import { AWARD_TYPE } from '@/enum'
import { getCookie, getDeviceId } from '@/util/util'
import { getChannelPageConfig, getRegisterAward } from '@/api/land'
import { platformTypeEnum } from '@ost/static'
import { getCouponMoneyOrTenths, getCouponTypeText, getDiscountTenthsType } from '@ost/static/lib/common/coupon'
export default {
  name: 'customLand',
  data () {
    return {
      platformTypeEnum,
      AWARD_TYPE,
      customData: {},
      registerPackage: []
    }
  },
  async created () {
    this.channelNo =
      this.$route.query.channelNo ||
      this.$route.query.channelCode ||
      getCookie('channelCode') ||
      ''
    try {
      await this.getCustomChannel()
      if (this.customData) {
        return
      }
    } catch (e) {
      console.error(e)
    }
    this.$emit('hide')
  },
  methods: {
    async getRegisterPackage () {
      try {
        const { data = [] } = await getRegisterAward({
          channelNo: this.channelNo,
          deviceId: getDeviceId(),
          reqType: 1
        })
        this.registerPackage = data.map((item) => {
          if (item?.awardList?.length) {
            item.awardList = item.awardList.map((x) => {
              x.isDiscountType = getDiscountTenthsType(x.discountType)
              x.awardMoney = getCouponMoneyOrTenths(x)
              x.couponTypeText = getCouponTypeText(x)
              return x
            })
          }
          return item
        })
      } catch (e) {
        console.error(e)
      }
    },
    async getCustomChannel () {
      try {
        const { data, code } = await getChannelPageConfig({
          channelNo: this.channelNo,
          platform: 2
        })
        const { bannerH5, pageDetailH5 } = data || {}
        if (code === 0 && (bannerH5 || pageDetailH5)) {
          this.customData = data
          this.getRegisterPackage()
        } else {
          this.$emit('hide')
        }
      } catch (e) {
        this.$emit('hide')
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>
.margin-left-xxs {
  margin-left: 4px;
}
img {
  width: 100%;
  vertical-align: middle;
}

.guide-award {
  padding: 28px 20px 16px;
  border-radius: 6px;
  overflow: hidden;
}

.guide-award-box {
  /*box-shadow: 0px 2px 6px 0px #FFECE7;*/
  background: #fff;
  border-radius: 10px 10px 16px 16px;
  overflow: hidden;
}

.guide-award-title {
  /*background: linear-gradient(180deg, #FDEFEB 0%, rgba(253, 239, 235, 0) 100%);*/
  font-weight: bold;
  background: linear-gradient(
    180deg,
    rgba(180, 221, 255, 0.99) 1%,
    rgba(180, 221, 255, 0) 100%
  );
  height: 50px;
  color: #1564ff;
  text-align: center;
  font-size: 18px;
  line-height: 50px;
  display: flex;
  justify-content: center;
}
.guide-award-title .text {
  margin: 0 10px;
}
.guide-award-title img {
  width: 24px !important;
}
.guide-award-main {
  margin: 0 16px;
  padding: 14px 0 10px 0;
}
.guide-award-content {
  padding-top: 8px;
  border-top: 1px dashed #b5b5b5;
}
.guide-award-item-name {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  color: #e66d1f;
  margin: 4px 0 10px 0;
}

.guide-award-item {
  display: flex;
  margin-bottom: 10px;
  height: 44px;
  background: url("https://cdn.evatmaster.com/ost/miniProgramStaticImages/activityGuide/coupon-bg.png")
    no-repeat;
  background-size: 100% 100%;
  align-items: center;
  padding: 0 22px;
  color: white;
}

.guide-award-img {
  width: 50px;
}
.guide-award-text {
  font-size: 15px;
  text-align: left;
  padding-right: 24px;
  border-right: 1px dashed white;
  font-size: 14px;
  margin-right: 24px;
}
.guide-award-text2{
  min-width: 80px;
  text-align: center;
}
.guide-award-text-icon {
  font-size: 14px;
  font-weight: bold;
}
.guide-award-text-price {
  font-size: 24px;
  font-weight: bold;
}
.guide-award-text-center {
  text-align: center;
  width: 100%;
}
.guide-award-unit {
  display: inline;
  color: #e66240;
}

.guide-award-unit {
  display: inline;
  color: #e66240;
}

.guide-award-item img {
  width: 100%;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/customLand.vue